import { throwIfGlobalInterruptRequestedWrapper } from './globalInterrupt'
import {
  evaluateXpath,
  getCaseInsensitiveAttribute,
  getCaseInsensitiveXPathTextSelector,
  getCaseInsensitiveString,
  getCommonAncestor,
  getNearestElementMatch,
} from './xpath'

const evaluateXpathInterruptible =
  throwIfGlobalInterruptRequestedWrapper(evaluateXpath)
const getCommonAncestorInterruptible =
  throwIfGlobalInterruptRequestedWrapper(getCommonAncestor)
const getNearestElementMatchInterruptible =
  throwIfGlobalInterruptRequestedWrapper(getNearestElementMatch)

export {
  evaluateXpathInterruptible as evaluateXpath,
  getCaseInsensitiveAttribute,
  getCaseInsensitiveXPathTextSelector,
  getCaseInsensitiveString,
  getCommonAncestorInterruptible as getCommonAncestor,
  getNearestElementMatchInterruptible as getNearestElementMatch,
}
